import { Dispatch } from "react";
import { encryptStorageUtils } from "../service/encryptStorage";
import { ActionType, actionTypes } from "../types/state";

const APP_INFO_LOCAL_STORAGE_KEY = "appInfo";

export function getAppUrl(): string | null {
  const url = window.env.DATA_LAKE_APP_URL?.trim();
  return url || null;
}

export function getLoginUrl(): string {
  const appUrl = getAppUrl();
  if (appUrl) {
    return `${appUrl.replace(/\/$/, "")}/login`;
  }
  return "/login";
}

export function getDashboardUrl(): string {
  const appUrl = getAppUrl();
  if (appUrl) {
    return `${appUrl.replace(/\/$/, "")}/dashboard`;
  }
  return "/dashboard";
}

export function redirectToLogin(): void {
  window.location.assign(getLoginUrl());
}

export function clearAuthSession(): void {
  try {
    encryptStorageUtils.clearKeyCloakTokens();
  } catch {
    // ignore
  }
  try {
    localStorage.removeItem(APP_INFO_LOCAL_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function logout(dispatch?: Dispatch<ActionType>): void {
  clearAuthSession();

  if (dispatch) {
    dispatch({
      type: actionTypes.setLoggedInUserInfo,
      value: undefined,
    });
  } else {
    encryptStorageUtils.setAuthTokenFromStorage("");
  }

  const appUrl = getAppUrl();
  window.location.assign(appUrl || "/");
}
